/**
 * @file index.js
 * @author fanyang06<fanyang@baidu.com>
 * @desc 华律 - 成员管理
 */

import bendsdk from '@baidu/bend-plugin-sdk';
const routes = [
    {
        path: '/platformLawyer',
        name: 'platformLawyer',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class customerList extends bendsdk.plugin {
    /**
     * 安装时执行的函数，用于向路由中添加路由。
     *
     * @param {Object} router - Vue Router 实例
     */
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
